import { render } from "./PickPeriodVidget.vue?vue&type=template&id=5a8c0164"
import script from "./PickPeriodVidget.vue?vue&type=script&lang=js"
export * from "./PickPeriodVidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__